/** Shared overlay + panel motion classes for modals (open/close). */

export const MODAL_PANEL_ANIMATION_MS = 720;
export const MODAL_SHEET_ANIMATION_MS = 320;

export type ModalMotionPhase = "idle" | "entering" | "open" | "exiting";

export function modalOverlayMotion(phase: ModalMotionPhase): string {
  switch (phase) {
    case "entering":
      return "aera-modal-fade-in";
    case "exiting":
      return "aera-modal-fade-out pointer-events-none";
    case "open":
      return "opacity-100";
    default:
      return "opacity-0 pointer-events-none";
  }
}

export function modalPanelMotion(phase: ModalMotionPhase): string {
  switch (phase) {
    case "entering":
      return "aera-bounce-in-down";
    case "exiting":
      return "aera-bounce-out-down";
    case "open":
      return "";
    default:
      return "opacity-0 pointer-events-none";
  }
}

export function modalSheetOverlayMotion(phase: ModalMotionPhase): string {
  switch (phase) {
    case "entering":
      return "workspace-picker-backdrop-in";
    case "exiting":
      return "workspace-picker-backdrop-out pointer-events-none";
    case "open":
      return "opacity-100";
    default:
      return "opacity-0 pointer-events-none";
  }
}

export function modalSheetPanelMotion(phase: ModalMotionPhase): string {
  switch (phase) {
    case "entering":
      return "workspace-picker-sheet-in";
    case "exiting":
      return "workspace-picker-sheet-out";
    case "open":
      return "";
    default:
      return "opacity-0 pointer-events-none translate-y-full";
  }
}

/** Right-edge drawer — always slides from the right. */
export function modalDrawerPanelMotion(phase: ModalMotionPhase): string {
  switch (phase) {
    case "entering":
      return "aera-drawer-right-in";
    case "exiting":
      return "aera-drawer-right-out";
    case "open":
      return "";
    default:
      return "opacity-0 pointer-events-none translate-x-full";
  }
}

/**
 * Bottom sheet below 900px, right drawer from 900px (912 mockups).
 * Animation direction is switched in CSS so layout cannot flash.
 */
export function modalResponsiveDrawerPanelMotion(
  phase: ModalMotionPhase,
): string {
  switch (phase) {
    case "entering":
      return "aera-responsive-drawer-in";
    case "exiting":
      return "aera-responsive-drawer-out";
    case "open":
      return "";
    default:
      return "opacity-0 pointer-events-none translate-y-full min-[900px]:translate-y-0 min-[900px]:translate-x-full";
  }
}

export function modalCenteredPopoverMotion(phase: ModalMotionPhase): string {
  return modalPanelMotion(phase);
}
